import { h, r as registerInstance, c as createEvent, f as forceUpdate, H as Host } from './index-DFuxYijk.js';
import { i as i18nProvider, l as loadTranslations } from './loadTranslations-CeCrhl7U.js';
import { g as getSoftwares, a as getSoftwareTypes, b as getErrorNumberRegexForTechnology, S as SOFTWARE_TYPES, c as getSoftwareModulesByType, d as createRequestData } from './createCase-Bs-WeQ_v.js';
import { g as getAuthClient, a as authClientName, A as ApiClient, s as setEnv, b as getEnvConfig, c as getPublicApiClient } from './publicApiClient-BFzlKRLe.js';
import { c as createStore, a as createAuthStore, w as whenAuthenticated, S as SilentAuth } from './auth-0jZC0MdX.js';

/**
 * This can be used like a Fragment in React. https://legacy.reactjs.org/docs/fragments.html
 */
var Fragment = (_props, children) => [...children];

const FormSteps = ({ multipleSteps }, children) => {
    if (!multipleSteps)
        return children;
    return h("ux-form-steps", null, children);
};
const FormStep = ({ multipleSteps }, children) => {
    if (!multipleSteps)
        return children;
    return h("ux-form-step", null, children);
};
const StepNavigation = ({ t, multipleSteps, currentStep }) => multipleSteps ? (h("div", { class: "ux-u-margin-top-40 ux-u-margin-bottom-40", style: { "min-height": "87px" } },
    h("ux-steps", null,
        h("ux-steps-item", { "data-ux-form-steps-prev": currentStep === 2 ? true : undefined, number: 1, current: currentStep === 1, done: currentStep === 2 }, t("headline.caseDetails")),
        h("ux-steps-item", { number: 2, current: currentStep === 2, "data-ux-form-steps-next": currentStep === 1 ? true : undefined }, t("headline.contactData"))))) : null;
const StepNext = ({ t, multipleSteps, onCancel }) => multipleSteps ? (h("div", { class: "ux-row" },
    h("div", { class: "ux-col-12 ux-u-margin-bottom-20" },
        h("div", { class: "ux-text-normal ux-text-normal--light-gray" },
            h("p", null, t("validation.requiredFieldsExplanation")))),
    h("div", { class: "ux-col-12" },
        h("div", { class: "ux-u-d-flex ux-u-flex-jc-between ux-u-flex-dir-row-reverse" },
            h("ux-button", { "data-ux-form-steps-next": true, variant: "primary" }, t("button.next")),
            h("ux-button", { type: "button", onClick: () => onCancel() }, t("button.cancel")))))) : null;
const StepBack = ({ t, multipleSteps }) => multipleSteps ? (h("ux-button", { "data-ux-form-steps-prev": true, type: "button" }, t("button.back"))) : null;

/**
 * Decodes a JWT token to an object
 * implementation from https://stackoverflow.com/questions/38552003/how-to-decode-jwt-token-in-javascript-without-using-a-library
 * @param token JWT token
 * @returns object
 */
function decodeJwt(token) {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join(""));
    return JSON.parse(jsonPayload);
}

const getAssets = async (apiClient) => {
    const idToken = getAuthClient(authClientName).getIdToken();
    const decoded = decodeJwt(idToken);
    const { customerNumber } = decoded;
    return apiClient
        .request(`/asset-management/1.0/core/assets/parameters?customerOrgId=${customerNumber}&isCustomOnly=false&isRootAsset=true`, {
        method: "GET",
        mockResponse
    })
        .then((response) => {
        if (response.assets) {
            return response.assets;
        }
        return Promise.reject("No assets found");
    });
};
const mockResponse = {
    assets: [
        {
            assetId: "A0660A0576",
            assetName: "Quicksharp",
            technologyId: "PUNCHING"
        },
        {
            assetId: "LS00093708",
            assetName: "HL 54P",
            technologyId: "PULSEDLASER"
        },
        {
            assetId: "E0551A0120",
            assetName: "HL 101P",
            technologyId: "PULSEDLASER"
        },
        {
            assetId: "LS00009160",
            assetName: "HL 2006D",
            technologyId: "PULSEDLASER"
        },
        {
            assetId: "LS00093844",
            assetName: "HL 2006D",
            technologyId: "PULSEDLASER"
        },
        {
            assetId: "N0053A0020",
            assetName: "SortMaster (AL28)",
            technologyId: "AUTOMATION"
        },
        {
            assetId: "C0200I0005",
            assetName: "Toolshuttle",
            technologyId: "AUTOMATION"
        },
        {
            assetId: "883850",
            assetName: "TRBV85SX",
            technologyId: "BENDING"
        },
        {
            assetId: "B0501A0185",
            assetName: "TruBend 5050",
            technologyId: "BENDING"
        },
        {
            assetId: "B1503I0001",
            assetName: "TruBend 5085 (B23)",
            technologyId: "BENDING"
        },
        {
            assetId: "B1504I0151",
            assetName: "TruBend 5130 (B23)",
            technologyId: "BENDING"
        },
        {
            assetId: "B1505I0280",
            assetName: "TruBend 5170 (B23)",
            technologyId: "BENDING"
        },
        {
            assetId: "B1505I0637",
            assetName: "TruBend 5170 (B23)",
            technologyId: "BENDING"
        },
        {
            assetId: "B1507I0001",
            assetName: "TruBend 5230 (B23)",
            technologyId: "BENDING"
        },
        {
            assetId: "B1509I0001",
            assetName: "TruBend 5320 (B23)",
            technologyId: "BENDING"
        },
        {
            assetId: "B0702A2028",
            assetName: "TruBend 7036",
            technologyId: "BENDING"
        },
        {
            assetId: "B0702A2031",
            assetName: "TruBend 7036",
            technologyId: "BENDING"
        },
        {
            assetId: "B1703I0086",
            assetName: "TruBend 7050 (B28)",
            technologyId: "BENDING"
        },
        {
            assetId: "E0953A0235",
            assetName: "TruDisk 2001 (4C)",
            technologyId: "DISKLASER"
        },
        {
            assetId: "E0953A0078",
            assetName: "TruDisk 4002 (4C)",
            technologyId: "DISKLASER"
        },
        {
            assetId: "E1153A0485",
            assetName: "TruDisk 4002 (4C)",
            technologyId: "DISKLASER"
        },
        {
            assetId: "E1153A0426",
            assetName: "TruDisk 6602 (4 C)",
            technologyId: "DISKLASER"
        },
        {
            assetId: "E0953A0227",
            assetName: "TruDisk 8002 (2C)",
            technologyId: "DISKLASER"
        },
        {
            assetId: "E1053A0162",
            assetName: "TruDisk  3001 (4 C)",
            technologyId: "DISKLASER"
        },
        {
            assetId: "A0221E0833",
            assetName: "TruLaser 3030 fiber (L49)",
            technologyId: "2DLASERCUTTING"
        },
        {
            assetId: "A0221E1065",
            assetName: "TruLaser 3030 fiber (L49)",
            technologyId: "2DLASERCUTTING"
        },
        {
            assetId: "A2221E0146",
            assetName: "TruLaser 3030 fiber (L95)",
            technologyId: "2DLASERCUTTING"
        },
        {
            assetId: "A3231E0025",
            assetName: "TruLaser 5030 fiber (L76)",
            technologyId: "2DLASERCUTTING"
        },
        {
            assetId: "A3231E0518",
            assetName: "TruLaser 5030 fiber (L76)",
            technologyId: "2DLASERCUTTING"
        },
        {
            assetId: "S2321M0144",
            assetName: "TruLaser Cell 3000 (L34)",
            technologyId: "WELDING"
        },
        {
            assetId: "S0541C0287",
            assetName: "TruLaser Cell 7040 (L31) fiber",
            technologyId: "3DLASERCUTTING"
        },
        {
            assetId: "S0541C0328",
            assetName: "TruLaser Cell 7040 (L31) fiber",
            technologyId: "3DLASERCUTTING"
        },
        {
            assetId: "A0280E0038",
            assetName: "TruLaser Center 7030 (L26)",
            technologyId: "2DLASERCUTTING"
        },
        {
            assetId: "A0280E0127",
            assetName: "TruLaser Center 7030 (L26)",
            technologyId: "2DLASERCUTTING"
        },
        {
            assetId: "A0455A0024",
            assetName: "TruLaser Robot 5020",
            technologyId: "LASERTUBECUTTING"
        },
        {
            assetId: "A0455A0037",
            assetName: "TruLaser Robot 5020",
            technologyId: "LASERTUBECUTTING"
        },
        {
            assetId: "A1441D0079",
            assetName: "TruLaser Tube 7000 fiber",
            technologyId: "LASERTUBECUTTING"
        },
        {
            assetId: "A0150A0160",
            assetName: "TruMatic 7000",
            technologyId: "COMBINED"
        },
        {
            assetId: "A1150D0126",
            assetName: "TruMatic 7000 (K08) Medium format",
            technologyId: "COMBINED"
        },
        {
            assetId: "A0460A0004",
            assetName: "TrumaWeld L 1000",
            technologyId: "WELDING"
        },
        {
            assetId: "A0420A0232",
            assetName: "TRUMPF Lasercell 1005",
            technologyId: "3DLASERCUTTING"
        },
        {
            assetId: "S0711Q0095",
            assetName: "TruPrint 1000 (G01)",
            technologyId: "3DPRINTING"
        },
        {
            assetId: "E0851A0036",
            assetName: "TruPulse 203",
            technologyId: "PULSEDLASER"
        },
        {
            assetId: "E0851A0048",
            assetName: "TruPulse 556",
            technologyId: "PULSEDLASER"
        },
        {
            assetId: "E0652A0387",
            assetName: "VectorMark Compact 1",
            technologyId: "MARKINGLASER"
        }
    ]
};

const getNotificationTypes = async (apiClient) => {
    return apiClient.request("/servicecall/getnotificationtypes", {
        mockResponse: mockNotificationTypes
    });
};
const NOTIFICATION_TYPES = {
    MACHINE_STOP: 20,
    FAULT_WITHOUT_STOP: 10,
    PROGRAMMING_SOFTWARE: -100,
    CLARIFICATION_SPARE_PARTS: 50,
    OTHER: 40,
    MAINTENANCE_REQUEST: 120,
    SPARE_PARTS_ORDER: 140,
    APPLICATION_ISSUES: 80
};
const mockNotificationTypes = [
    {
        Id: NOTIFICATION_TYPES.MACHINE_STOP,
        LabelKey: "Maschinenstillstand"
    },
    {
        Id: NOTIFICATION_TYPES.FAULT_WITHOUT_STOP,
        LabelKey: "Störung ohne Stillstand"
    },
    {
        Id: NOTIFICATION_TYPES.PROGRAMMING_SOFTWARE,
        LabelKey: "Programmierung / Software"
    },
    {
        Id: NOTIFICATION_TYPES.CLARIFICATION_SPARE_PARTS,
        LabelKey: "Klärung Ersatzteile"
    },
    {
        Id: NOTIFICATION_TYPES.OTHER,
        LabelKey: "Sonstiges"
    },
    {
        Id: NOTIFICATION_TYPES.MAINTENANCE_REQUEST,
        LabelKey: "Wartungsanfrage"
    },
    {
        Id: NOTIFICATION_TYPES.SPARE_PARTS_ORDER,
        LabelKey: "Bestellung Ersatzteile"
    },
    {
        Id: NOTIFICATION_TYPES.APPLICATION_ISSUES,
        LabelKey: "Applikationsthemen"
    }
];

const getUserDetails = async (apiClient) => {
    return apiClient.request("/user/getuserdetails", {
        mockResponse: mockUserDetails
    });
};
const mockUserDetails = {
    userId: "ServiceDE",
    salutation: "2",
    title: null,
    firstname: "Marc",
    surname: "Wenzler",
    email: "Marc.Wenzler.DEMO_TWDE1@de.trumpf.com",
    phone: "+49715630334317",
    fax: null,
    position: "Testuser Service App deutsch",
    language: "de",
    customerNo: "270763",
    company: "MyTRUMPF DEMO DE",
    street: "Johann-Maus-Straße 2",
    zipCode: "71254",
    city: "Ditzingen",
    state: null,
    country: "DE",
    status: "Activated",
    customerAdmin: "false",
    userRoles: ["confirmed", "service_full", "order_use", "order_read", "service_read", "order_full", "customer"]
};

const mapUserDetailsToContactInfo = (userDetails) => {
    return {
        salutation: getSalutation(userDetails.salutation),
        firstName: userDetails.firstname,
        lastName: userDetails.surname,
        email: userDetails.email,
        phone: userDetails.phone
    };
};
const getSalutation = (salutation) => {
    if (typeof salutation === "string") {
        const parsed = parseInt(salutation, 10);
        return isNaN(parsed) ? null : parsed;
    }
    return null;
};

const createApiStore = () => {
    const store = createStore({
        machinesLoading: true,
        machines: [],
        softwaresLoading: true,
        softwares: [],
        softwareTypes: [],
        notificationTypesLoading: true,
        notificationTypes: [],
        userDetailsLoading: true,
        contactInfo: null,
        isAllowedToCreateCase: null,
        loading: true
    });
    store.onChange("machinesLoading", () => updateLoading());
    store.onChange("softwaresLoading", () => updateLoading());
    store.onChange("notificationTypesLoading", () => updateLoading());
    store.onChange("userDetailsLoading", () => updateLoading());
    function updateLoading() {
        const { machinesLoading, softwaresLoading, notificationTypesLoading, userDetailsLoading } = store.state;
        store.state.loading = machinesLoading || softwaresLoading || notificationTypesLoading || userDetailsLoading;
    }
    return store;
};
const loadFormDataFromPublicApi = async (apiStore, apiClient) => {
    apiStore.state.softwaresLoading = true;
    apiStore.state.notificationTypesLoading = true;
    getSoftwares(apiClient).then((softwares) => {
        apiStore.state.softwares = softwares;
        apiStore.state.softwareTypes = getSoftwareTypes(softwares);
        apiStore.state.softwaresLoading = false;
    });
    getNotificationTypes(apiClient).then((notificationTypes) => {
        apiStore.state.notificationTypes = notificationTypes;
        apiStore.state.notificationTypesLoading = false;
    });
    getUserDetails(apiClient).then((userDetails) => {
        var _a;
        apiStore.state.contactInfo = mapUserDetailsToContactInfo(userDetails);
        apiStore.state.isAllowedToCreateCase = ((_a = userDetails.userRoles) === null || _a === void 0 ? void 0 : _a.includes("service_full")) || false;
        apiStore.state.userDetailsLoading = false;
    });
};
const loadFormDataFromAssetManagementApi = async (apiStore, apiClient) => {
    apiStore.state.machinesLoading = true;
    getAssets(apiClient).then((machines) => {
        apiStore.state.machines = machines;
        apiStore.state.machinesLoading = false;
    });
};

const APPLICATION_IDS = {
    WELDING: 1,
    PLASTIC: 2,
    CUTTING: 3,
    HARDENING: 4,
    MARKING: 5,
    OTHER: 6,
    FIXED_OPTICS_BEO: 7,
    PFO20_33: 8,
    PFO3D: 9,
    I_PFO: 10,
    OTHER_OPTICS: 11,
    WELD_DEPTH: 12,
    HARDNESS: 13,
    CRACKING: 14,
    BUBBLE_SPLATTER: 15,
    PROCESS_DATA: 16,
    OTHER_WELDING: 17
};
const applicationsLaser = [
    {
        labelKey: "welding",
        id: APPLICATION_IDS.WELDING
    },
    {
        labelKey: "plastic",
        id: APPLICATION_IDS.PLASTIC
    },
    {
        labelKey: "cutting",
        id: APPLICATION_IDS.CUTTING
    },
    {
        labelKey: "hardening",
        id: APPLICATION_IDS.HARDENING
    },
    {
        labelKey: "marking",
        id: APPLICATION_IDS.MARKING
    },
    {
        labelKey: "other",
        id: APPLICATION_IDS.OTHER
    }
];
const applicationsOptics = [
    {
        labelKey: "fixedOpticsBEO",
        id: APPLICATION_IDS.FIXED_OPTICS_BEO
    },
    {
        labelKey: "PFO20/33",
        id: APPLICATION_IDS.PFO20_33
    },
    {
        labelKey: "PFO3D",
        id: APPLICATION_IDS.PFO3D
    },
    {
        labelKey: "I-PFO",
        id: APPLICATION_IDS.I_PFO
    },
    {
        labelKey: "other",
        id: APPLICATION_IDS.OTHER_OPTICS
    }
];
const applicationsWelding = [
    {
        labelKey: "weldDepth",
        id: APPLICATION_IDS.WELD_DEPTH
    },
    {
        labelKey: "hardness",
        id: APPLICATION_IDS.HARDNESS
    },
    {
        labelKey: "cracking",
        id: APPLICATION_IDS.CRACKING
    },
    {
        labelKey: "bubbleSplatter",
        id: APPLICATION_IDS.BUBBLE_SPLATTER
    },
    {
        labelKey: "processData",
        id: APPLICATION_IDS.PROCESS_DATA
    },
    {
        labelKey: "other",
        id: APPLICATION_IDS.OTHER_WELDING
    }
];

const hideMachinesForNotificationTypes = [NOTIFICATION_TYPES.PROGRAMMING_SOFTWARE];
const showErrorNumbersForNotificationTypes = [
    null,
    NOTIFICATION_TYPES.APPLICATION_ISSUES,
    NOTIFICATION_TYPES.MACHINE_STOP,
    NOTIFICATION_TYPES.FAULT_WITHOUT_STOP
];
const hideErrorNumbersForTechnologies = [];
const showSoftwareFieldsForNotificationTypes = [NOTIFICATION_TYPES.PROGRAMMING_SOFTWARE];
const showSoftwareModulesForSoftwareTypes = [SOFTWARE_TYPES.TRUTOPS, SOFTWARE_TYPES.TRUTOPS_FAB, SOFTWARE_TYPES.TRUTOPS_BOOST];
const showApplicationIssuesForNotificationTypes = [NOTIFICATION_TYPES.APPLICATION_ISSUES];
const showApplicationIssuesForTechnologies = [
    "PULSEDLASER",
    "SHORTPULSEDLASER",
    "DISKLASER",
    "FIBERLASER",
    "DIODELASER",
    "MARKINGLASER"
];
const showWeldingApplicationFieldsForApplication = [APPLICATION_IDS.WELDING];
const createFormStore = () => {
    const store = createStore({
        selectedNotificationType: null,
        selectedSoftwareType: null,
        selectedApplication: null,
        formIsSubmitted: false,
        selectedMachineTechnology: null,
        showErrorNumbers: true,
        showApplications: false,
        showSoftwareModules: false,
        showMachines: true,
        showSoftwareFields: false,
        showWeldingApplicationFields: false,
        errorNumberRegex: getErrorNumberRegexForTechnology()
    });
    store.onChange("selectedNotificationType", (selectedNotificationType) => {
        store.state.showMachines = !hideMachinesForNotificationTypes.includes(selectedNotificationType);
        store.state.showSoftwareFields = showSoftwareFieldsForNotificationTypes.includes(selectedNotificationType);
        determineShowErrorNumbers();
        determineShowApplications();
    });
    store.onChange("selectedMachineTechnology", () => {
        determineShowErrorNumbers();
        determineShowApplications();
        determineErrorNumberRegex();
    });
    store.onChange("selectedApplication", (selectedApplication) => {
        store.state.showWeldingApplicationFields = showWeldingApplicationFieldsForApplication.includes(selectedApplication);
    });
    store.onChange("selectedSoftwareType", (selectedSoftwareType) => {
        store.state.showSoftwareModules = showSoftwareModulesForSoftwareTypes.includes(selectedSoftwareType);
    });
    function determineShowApplications() {
        const { selectedNotificationType, selectedMachineTechnology } = store.state;
        store.state.showApplications =
            showApplicationIssuesForNotificationTypes.includes(selectedNotificationType) &&
                showApplicationIssuesForTechnologies.includes(selectedMachineTechnology);
    }
    function determineErrorNumberRegex() {
        const { selectedMachineTechnology } = store.state;
        store.state.errorNumberRegex = getErrorNumberRegexForTechnology(selectedMachineTechnology);
    }
    function determineShowErrorNumbers() {
        const { selectedNotificationType, selectedMachineTechnology } = store.state;
        store.state.showErrorNumbers =
            showErrorNumbersForNotificationTypes.includes(selectedNotificationType) &&
                !(selectedMachineTechnology !== null && hideErrorNumbersForTechnologies.includes(selectedMachineTechnology));
    }
    return store;
};

const ErrorNumberInput = ({ t, prefillData, formStore }) => {
    var _a, _b, _c, _d;
    return (h("div", { class: "ux-u-margin-bottom-20" },
        h("label", { class: "ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase" }, t("field.errorNumber.label")),
        h("service-calls-dynamic-input", { "add-text": t("field.errorNumber.addAnotherNumber"), "input-name": "errorNumber1", prefilledValues: ((_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.productData) === null || _a === void 0 ? void 0 : _a.errorNumbers) || [], "init-items": ((_c = (_b = prefillData === null || prefillData === void 0 ? void 0 : prefillData.productData) === null || _b === void 0 ? void 0 : _b.errorNumbers) === null || _c === void 0 ? void 0 : _c.length) || 1, "min-items": "1", "max-items": "6", disabled: !!((_d = prefillData === null || prefillData === void 0 ? void 0 : prefillData.productData) === null || _d === void 0 ? void 0 : _d.errorNumbers), regex: formStore.state.errorNumberRegex, "error-message": t("field.errorNumber.errorMessage") },
            h("div", { class: "mf-create-service-case__help-block", slot: "info" },
                h("p", { class: "ux-text-tiny" }, t("field.errorNumber.explanation", {
                    example1: "0000FC00",
                    example2: "1.10.58102409",
                    example3: "6000"
                }))))));
};

const SALUTATION = {
    FEMALE: 1,
    MALE: 2
};

const getLanguageFromLocale = (locale) => {
    if (!locale.includes("-")) {
        return locale;
    }
    return locale.split("-")[0];
};
const getCountryFromLocale = (locale) => {
    if (!locale.includes("-")) {
        return null;
    }
    return locale.split("-")[1];
};

const SalutationInput = ({ t, apiStore }) => {
    var _a, _b, _c;
    return (h("ux-select", { label: t("field.salutation.label"), required: true, name: "salutation" },
        h("option", { value: "", selected: typeof ((_a = apiStore.state.contactInfo) === null || _a === void 0 ? void 0 : _a.salutation) !== "number", disabled: true }, t("select.placeholder")),
        h("option", { value: SALUTATION.FEMALE, selected: ((_b = apiStore.state.contactInfo) === null || _b === void 0 ? void 0 : _b.salutation) === SALUTATION.FEMALE }, t("field.salutation.female")),
        h("option", { value: SALUTATION.MALE, selected: ((_c = apiStore.state.contactInfo) === null || _c === void 0 ? void 0 : _c.salutation) === SALUTATION.MALE }, t("field.salutation.male"))));
};
const FirstNameInput = ({ t, apiStore }) => {
    var _a;
    return (h("ux-input-field", { "data-validation-required--msg": t("validation.requiredField"), "data-validation-length--max": "45", "data-validation-length--msg": t("validation.maxAllowedCharacters", {
            number: 45
        }), label: t("field.firstName.label"), name: "firstName", value: ((_a = apiStore.state.contactInfo) === null || _a === void 0 ? void 0 : _a.firstName) || "", required: true }));
};
const LastNameInput = ({ t, apiStore }) => {
    var _a;
    return (h("ux-input-field", { "data-validation-required--msg": t("validation.requiredField"), "data-validation-length--max": "45", "data-validation-length--msg": t("validation.maxAllowedCharacters", {
            number: 45
        }), label: t("field.lastName.label"), name: "lastName", value: ((_a = apiStore.state.contactInfo) === null || _a === void 0 ? void 0 : _a.lastName) || "", required: true }));
};
const PhoneInput = ({ t, apiStore, locale }) => {
    var _a, _b;
    return (h("ux-phone-input", { label: t("field.phone.label"), language: getLanguageFromLocale(locale), country: !((_a = apiStore.state.contactInfo) === null || _a === void 0 ? void 0 : _a.phone) ? getCountryFromLocale(locale) : undefined, "data-validation-invalid--msg": t("validation.invalidPhoneNumber"), "data-validation-required--msg": t("validation.requiredField"), name: "phone", value: ((_b = apiStore.state.contactInfo) === null || _b === void 0 ? void 0 : _b.phone) || "", required: true }));
};
const EmailInput = ({ t, apiStore }) => {
    var _a;
    return (h("ux-input-field", { type: "email", required: true, "data-validation-required--msg": t("validation.requiredField"), "data-validation-length--max": "100", "data-validation-length--msg": t("validation.maxAllowedCharacters", {
            number: 100
        }), "data-validation-invalid--msg": t("validation.invalidEmail"), label: "E-Mail", name: "email", value: ((_a = apiStore.state.contactInfo) === null || _a === void 0 ? void 0 : _a.email) || "" }));
};

const classifications = ["standstill", "fault", "slightImpairment", "generalInquiry"];

const SoftwareModuleSelect = ({ t, prefillData, formStore, apiStore }) => {
    var _a, _b;
    return (h("ux-select", { required: true, label: t("field.softwareModule.label"), "data-validation-required--msg": t("validation.requiredField"), name: "softwareModule", disabled: (_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _a === void 0 ? void 0 : _a.softwareModule },
        h("option", { value: "", selected: !((_b = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _b === void 0 ? void 0 : _b.softwareModule), disabled: true }, t("select.placeholder")),
        getSoftwareModulesByType(apiStore.state.softwares, formStore.state.selectedSoftwareType).map((softwareModule) => {
            var _a;
            return (h("option", { value: softwareModule, selected: softwareModule === ((_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _a === void 0 ? void 0 : _a.softwareModule) }, t(`softwareModule.${softwareModule}`)));
        })));
};
const SoftwareTypeSelect = ({ t, prefillData, formStore, apiStore }) => {
    var _a, _b;
    return (h("ux-select", { required: true, label: t("field.softwareType.label"), name: "softwareType", onUxChange: (event) => {
            formStore.state.selectedSoftwareType = event.detail.value;
        }, disabled: (_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _a === void 0 ? void 0 : _a.softwareType },
        h("option", { value: "", selected: !((_b = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _b === void 0 ? void 0 : _b.softwareType), disabled: true }, t("select.placeholder")),
        apiStore.state.softwareTypes.map((softwareType) => {
            var _a;
            return (h("option", { value: softwareType, selected: ((_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _a === void 0 ? void 0 : _a.softwareType) === softwareType }, softwareType));
        })));
};
const SoftwareClassificationSelect = ({ t, prefillData }) => {
    var _a;
    const hasPrefilledClassification = classifications.includes((_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _a === void 0 ? void 0 : _a.softwareProblemClassification);
    return (h("ux-select", { required: true, label: t("field.softwareProblemClassification.label"), "data-validation-required--msg": t("validation.requiredField"), name: "softwareProblemClassification" },
        h("option", { value: "", selected: !hasPrefilledClassification, disabled: true }, t("select.placeholder")),
        classifications.map((classification) => {
            var _a;
            return (h("option", { value: classification, selected: classification === ((_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _a === void 0 ? void 0 : _a.softwareProblemClassification) }, t(`softwareProblemClassification.${classification}`)));
        })));
};
const InstallationCheckbox = ({ t, prefillData }) => {
    var _a, _b;
    return (h("ux-checkbox", { label: t("field.softwareInstallationProblem.label"), name: "installationProblem", checked: (_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _a === void 0 ? void 0 : _a.isInstallationProblem, disabled: typeof ((_b = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _b === void 0 ? void 0 : _b.isInstallationProblem) === "boolean" }));
};
const LicenseCheckbox = ({ t, prefillData }) => {
    var _a, _b;
    return (h("ux-checkbox", { label: t("field.softwareLicenseIssue.label"), name: "licenseIssue", checked: (_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _a === void 0 ? void 0 : _a.isLicenseIssue, disabled: typeof ((_b = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _b === void 0 ? void 0 : _b.isLicenseIssue) === "boolean" }));
};

const ApplicationSelect = ({ t, formStore, prefillData }) => (h("ux-select", { required: true, label: t("field.application.label"), "data-validation-required--msg": t("validation.requiredField"), name: "application", onUxChange: (event) => {
        formStore.state.selectedApplication = Number(event.detail.value);
    } },
    h("option", { value: "", selected: true, disabled: true }, t("select.placeholder")),
    applicationsLaser.map((application) => {
        var _a;
        return (h("option", { value: application.id, selected: (_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.applicationTopicIds) === null || _a === void 0 ? void 0 : _a.includes(application.id) }, t(`application.${application.labelKey}`)));
    })));
const ApplicationOpticsSelect = ({ t, prefillData }) => (h("ux-select", { label: t("field.optics.label"), name: "optics" },
    h("option", { value: "", selected: true, disabled: true }, t("select.placeholder")),
    applicationsOptics.map((application) => {
        var _a;
        return (h("option", { value: application.id, selected: (_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.applicationTopicIds) === null || _a === void 0 ? void 0 : _a.includes(application.id) }, t(`application.${application.labelKey}`)));
    })));
const ApplicationIssueSelect = ({ t, prefillData }) => (h("ux-select", { label: t("field.applicationIssue.label"), name: "applicationIssue" },
    h("option", { value: "", selected: true, disabled: true }, t("select.placeholder")),
    applicationsWelding.map((application) => {
        var _a;
        return (h("option", { value: application.id, selected: (_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.applicationTopicIds) === null || _a === void 0 ? void 0 : _a.includes(application.id) }, t(`application.${application.labelKey}`)));
    })));

const MachineSelect = ({ t, prefillData, apiStore, formStore }) => {
    var _a, _b;
    const { machines } = apiStore.state;
    return (h("ux-select", { required: true, label: t("field.machine.label"), "data-validation-required--msg": t("validation.requiredField"), name: "productNo", onUxChange: (event) => {
            const machine = machines.find(({ assetId }) => assetId === event.detail.value);
            if (machine) {
                formStore.state.selectedMachineTechnology = machine.technologyId;
                return;
            }
            // eslint-disable-next-line no-console
            console.error(`Machine with id ${event.detail.value} not found`);
        }, disabled: (_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.productData) === null || _a === void 0 ? void 0 : _a.assetId },
        h("option", { value: "", selected: !((_b = prefillData === null || prefillData === void 0 ? void 0 : prefillData.productData) === null || _b === void 0 ? void 0 : _b.assetId), disabled: true }, t("select.placeholder")),
        machines.map((machine) => {
            var _a;
            return (h("option", { key: machine.assetId, value: machine.assetId, selected: machine.assetId === ((_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.productData) === null || _a === void 0 ? void 0 : _a.assetId) },
                machine.assetName,
                " (",
                machine.assetId,
                ")"));
        })));
};

const NotificationTypeSelect = ({ t, prefillData, apiStore, formStore }) => {
    const { notificationTypes } = apiStore.state;
    const { selectedNotificationType } = formStore.state;
    return (h("ux-select", { required: true, label: t("field.reason.label"), "data-validation-required--msg": t("validation.requiredField"), name: "notificationType", onUxChange: (event) => {
            formStore.state.selectedNotificationType = Number(event.detail.value);
        }, disabled: prefillData === null || prefillData === void 0 ? void 0 : prefillData.notificationType },
        h("option", { value: "", selected: !(prefillData === null || prefillData === void 0 ? void 0 : prefillData.notificationType), disabled: true }, t("select.placeholder")),
        notificationTypes.map((notificationType) => (h("option", { key: String(notificationType.LabelKey), value: notificationType.Id, selected: notificationType.Id === selectedNotificationType }, t(`notificationType.${notificationType.LabelKey}`))))));
};

const assetManagementApiClients = {};
const getAssetManagementApiClient = (config) => {
    const { assetManagementApiBaseUrl, authIssuer, authScope, authClientId } = config;
    const key = `${assetManagementApiBaseUrl}-${authIssuer}-${authScope}-${authClientId}`;
    if (!assetManagementApiClients[key]) {
        assetManagementApiClients[key] = new AssetManagementApiClient(config);
    }
    return assetManagementApiClients[key];
};
class AssetManagementApiClient extends ApiClient {
    /**
     * Request function to send an authenticated POST request to the AssetManagementAPI
     */
    async request(path, options) {
        if (this.config.useMockData) {
            return this.mockRequest(options === null || options === void 0 ? void 0 : options.mockResponse);
        }
        if (this.authClientServiceCalls === null) {
            return Promise.reject("AuthClient not initialized");
        }
        const { method = "POST", headers: additionalHeaders = {}, body: bodyObject } = options || {};
        const headers = Object.assign({ Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${this.token}` }, additionalHeaders);
        const body = bodyObject ? JSON.stringify(bodyObject) : undefined;
        return fetch(`${this.config.assetManagementApiBaseUrl}${path}`, {
            method,
            headers,
            body
        }).then((response) => {
            if (response.status === 401) {
                this.authClientServiceCalls.deleteAccessToken();
                return Promise.reject("Unauthorized");
            }
            if (response.status === 200) {
                return response.json();
            }
            return Promise.reject(`Error ${response.status}`);
        });
    }
}

const DescriptionInput = ({ t, prefillData }) => (h("ux-textarea-field", { label: t("field.message.label"), placeholder: t("field.message.placeholder"), value: (prefillData === null || prefillData === void 0 ? void 0 : prefillData.description) || "", required: true, "data-validation-required--msg": t("validation.requiredField"), name: "description" }));

const createServiceCaseCss = ".mf-create-service-case{display:block}.mf-create-service-case__button-group{display:flex;gap:0 10px;}mf-create-service-case ux-select{width:100%}";

const MfCreateServiceCase = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.serviceCaseSubmit = createEvent(this, "mfServiceCaseSubmit");
        this.serviceCaseCancel = createEvent(this, "mfServiceCaseCancel");
        /**
         * If true, the form will be displayed in multiple steps
         */
        this.multipleSteps = false;
        /**
         * Enable file upload in the form
         */
        this.fileUpload = false;
        /**
         * Data that should be prefilled in the form
         * @optional
         */
        this.prefillData = null;
        /**
         * Application name that will be used as origin of the source when sending the form.
         * This can be overridden by the prefillData.origin
         */
        this.origin = "";
        /**
         * The locale to use for translations and the phone input
         */
        this.locale = "en-US";
        /**
         * Environment string to decide which endpoints to use
         */
        this.env = "prod";
        /**
         * use onprem Public API instead of azure
         * @deprecated only used until April 2025
         */
        this.legacyApi = false;
        /**
         * disable silent auth - then the application needs to supply the auth token via @trumpf/ux.utils
         * @optional
         */
        this.disableSilentAuth = false;
        this.tbdbError = null;
        this.apiStore = createApiStore();
        this.authStore = createAuthStore();
        this.formStore = createFormStore();
        this.callId = crypto.randomUUID(); // this browser API only works on localhost and over https
    }
    connectedCallback() {
        setEnv(`${this.env}${this.legacyApi ? "Legacy" : ""}`);
        this.config = getEnvConfig();
        this.publicApiClient = getPublicApiClient(this.config);
        this.unsubscribeToTbdbToken = this.publicApiClient.subscribeToTbdbToken((event) => {
            if (event.success) {
                loadFormDataFromPublicApi(this.apiStore, this.publicApiClient);
            }
            else {
                this.tbdbError = event.errorMessage || "Error getting TBDB token";
            }
        });
        this.assetManagementApiClient = getAssetManagementApiClient(this.config);
        this.loadTranslations();
        this.i18nSubscriberId = i18nProvider.subscribe(() => forceUpdate(this));
        this.unsubscribeAuth = whenAuthenticated(() => loadFormDataFromAssetManagementApi(this.apiStore, this.assetManagementApiClient));
        this.apiStore.onChange("notificationTypesLoading", (notificationTypesLoading) => {
            var _a;
            if (!notificationTypesLoading) {
                this.formStore.state.selectedNotificationType = ((_a = this.prefillData) === null || _a === void 0 ? void 0 : _a.notificationType) || null;
            }
        });
    }
    disconnectedCallback() {
        this.unsubscribeAuth();
        i18nProvider.unsubscribe(this.i18nSubscriberId);
        if (this.unsubscribeToTbdbToken) {
            this.unsubscribeToTbdbToken();
        }
    }
    onLocaleChange() {
        if (this.locale !== i18nProvider.language) {
            this.loadTranslations();
        }
    }
    onPrefillDataChange() {
        var _a;
        const notificationType = (_a = this.prefillData) === null || _a === void 0 ? void 0 : _a.notificationType;
        if (notificationType) {
            this.formStore.state.selectedNotificationType = notificationType;
        }
    }
    loadTranslations() {
        loadTranslations(this.locale).then((locale) => {
            i18nProvider.changeLanguage(locale);
            this.locale = locale;
        });
    }
    onSubmit(event) {
        var _a;
        event.preventDefault();
        const { softwares } = this.apiStore.state;
        const { form, callId, origin, formStore } = this;
        const data = createRequestData({
            form,
            callId,
            softwares,
            origin: ((_a = this.prefillData) === null || _a === void 0 ? void 0 : _a.origin) || origin,
            selectedMachineTechnology: formStore.state.selectedMachineTechnology
        });
        const files = this.fileUpload
            ? Array.from(form.querySelectorAll("input[type='file']")).reduce((acc, input) => {
                return acc.concat(Array.from(input.files || []));
            }, [])
            : [];
        this.serviceCaseSubmit.emit({ data, callId, files });
        formStore.state.formIsSubmitted = true;
        if (this.config.logging) {
            // eslint-disable-next-line no-console
            console.log("Form submitted", data);
        }
    }
    onCancel() {
        this.serviceCaseCancel.emit();
    }
    render() {
        const t = (key, options = undefined) => i18nProvider.t(`mf-service-calls:${String(key)}`, options);
        const { isAllowedToCreateCase, loading } = this.apiStore.state;
        const { isAuthenticating, authError } = this.authStore.state;
        const { prefillData, multipleSteps } = this;
        const { showErrorNumbers, formIsSubmitted, showApplications, showSoftwareModules, showMachines, showSoftwareFields, showWeldingApplicationFields } = this.formStore.state;
        const showContent = isAllowedToCreateCase && !(loading || isAuthenticating || authError);
        return (h(Host, { key: 'e811d634a41a348072864ab988994ec811abc7f2' }, !formIsSubmitted && (h("ux-form", { key: '5f991968ee047243355c0aa1a91013c690d079cc', "data-validation-required--msg": t("validation.requiredField") }, h(FormSteps, { key: 'fbd3189ccca81b726b2a96b83f80d67e1336f486', multipleSteps: multipleSteps }, h("form", { key: '4c4fc8c632d6b33f04715339c82bc78722d96f15', onSubmit: (e) => this.onSubmit(e), ref: (el) => (this.form = el) }, h("div", { key: '0959d0e5c694ff35d15301c35aa8027a21fbbf8e', class: "ux-u-text-align--center ux-u-margin-top-60 ux-u-margin-bottom-60" }, h("div", { key: '05624099f9afca58a08a8e2f452c1a981bff02dc', class: "ux-text-headline ux-text-headline--giant" }, t("headline.createCase"))), (loading || isAuthenticating) && (h("ux-loader", { key: '200014066b9602fc05ca91364189fe6683e21a99', class: "ux-u-margin-bottom-40", variant: "spinner" })), authError && (h("div", { key: '7f5f682f9366baa450eff1dccded96fd32e44a2a', class: "ux-u-text-align--center ux-text-normal ux-u-margin-top-20 ux-u-margin-bottom-20" }, t("auth.error"))), isAllowedToCreateCase === false && (h("div", { key: '025a084dcb31b898bd61a9f1d09ecd250b635481', class: "ux-u-text-align--center ux-text-normal ux-u-margin-top-20 ux-u-margin-bottom-20" }, t("missingAuthorization"))), h("div", { key: 'f3b6047344293e7776b10822e65fcd5ff71e4dbf', style: { display: showContent ? "block" : "none" } }, h(FormStep, { key: '3bb29a4f0a41c698fab7078d7e200f8c1bf479ed', multipleSteps: multipleSteps }, h(StepNavigation, { key: '830c060c81e05ed12f9bbeed6a4e71f51162729f', t: t, multipleSteps: multipleSteps, currentStep: 1 }), h("div", { key: 'f5c7089841f72b442432df2dee4449d73fcb537f', class: "ux-row ux-u-flex-jc-center" }, h("div", { key: 'e18054eb2ad77b4158d806324671cca957ff6c2b', class: "ux-col-12 ux-col-md-10" }, h("div", { key: '0a7a9c222e959644db24c0c7f01ac4f8692ba2bf', class: "ux-row" }, h("div", { key: 'bf592d5d88a6b84ad060e972ad1e3f8ce3b9a50b', class: "ux-col-12 ux-col-md-6" }, h("div", { key: 'b30955637a478cb2dfe0f6b464354b2901610856', class: "ux-u-margin-bottom-20" }, h(NotificationTypeSelect, { key: '18dcf9599c1658649e0522010f95b07a1b675941', t: t, prefillData: prefillData, formStore: this.formStore, apiStore: this.apiStore }))), showMachines && (h("div", { key: '00be714e4b009415afd871de014cc38a3cdf7acf', class: "ux-col-12 ux-col-md-6" }, h("div", { key: 'd8aea14a2b8c0b2bbbb11a8f7b0bd0e8922430c5', class: "ux-u-margin-bottom-20" }, h(MachineSelect, { key: '71b4ea21bceed13eadfb361450404901331c83c8', t: t, prefillData: prefillData, formStore: this.formStore, apiStore: this.apiStore }))))), showApplications && (h(Fragment, { key: '75351e8fca7bcb0ec930db45d3dbebc5c20afb0e' }, h("div", { key: 'f446fa882eae55717bd1feba5b5865a8e399ba31', class: "ux-row" }, h("div", { key: 'c67b7a3aeaad939182ddcb1d200b23cfebc69e70', class: "ux-col-12 ux-col-md-6" }, h("div", { key: '6df05df0debb75a6c84f839750f53142865dba13', class: "ux-u-margin-bottom-20" }, h(ApplicationSelect, { key: '0f89651731625c1ab8a7687af89bb9c8a0af4e47', t: t, formStore: this.formStore, prefillData: prefillData })))), showWeldingApplicationFields && (h("div", { key: '4a9e0c127797e2f157d5d5f8b9cd10e679a79756', class: "ux-row" }, h("div", { key: '7c44990322943d8d4f55f006c3f0a1feed8b5da5', class: "ux-col-12 ux-col-md-6" }, h("div", { key: '7a77e51ebc6cb6e636db72b736b2a0b0ffa95e3a', class: "ux-u-margin-bottom-20" }, h(ApplicationOpticsSelect, { key: '671f9d05868b2c394acbbae8399cef6604b73a2f', t: t, prefillData: prefillData }))), h("div", { key: '1d8d56a500e0345b03495c3a61d08b8cc8a4dcd6', class: "ux-col-12 ux-col-md-6" }, h("div", { key: 'a8d1ac2b31f911bd2119f3bf85abc9c265b8ffc0', class: "ux-u-margin-bottom-20" }, h(ApplicationIssueSelect, { key: '1bfdb2d035758e99e2d46832ad6a95531738edd5', t: t, prefillData: prefillData }))))))), showSoftwareFields && (h(Fragment, { key: 'e152da47f461a9689ce611adb1e08e98f3517fe5' }, h("div", { key: '4562c7477ac464c67acc2f30cda9fb384e3fde35', class: "ux-row" }, h("div", { key: 'c7e1b4e5408a56fe8ee1b9830097b30df2609afc', class: "ux-col-12 ux-col-md-6" }, h("div", { key: '32f09630d962f4a82b2905e5b89caedc565242de', class: "ux-u-margin-bottom-20" }, h(SoftwareClassificationSelect, { key: '5d3ccf717a95d7458c3ba4c387773edb5d89c956', t: t, prefillData: prefillData })))), h("div", { key: '7eb06205a01f875e49845a4731dfa45cbf2647c7', class: "ux-row" }, h("div", { key: '818ede4000fee334c08f05789cda45d586b62e83', class: "ux-col-12 ux-col-md-6" }, h("div", { key: '76594a16d2a806e0fcb5fd553b56d6e40561b5ca', class: "ux-u-margin-bottom-20" }, h(InstallationCheckbox, { key: 'df8f435cdf7e95c8d3781b2668df6e823bd201ee', t: t, prefillData: prefillData }))), h("div", { key: '5f7cdd28163fc8f1affefe89d000e212866c8f8c', class: "ux-col-12 ux-col-md-6" }, h("div", { key: '33a48c6df611ff1fcef6f7b9dd742beb6ba9077d', class: "ux-u-margin-bottom-20" }, h(LicenseCheckbox, { key: '02ac98c4fbf5129a9e92963838beedd4fdfec892', t: t, prefillData: prefillData })))), h("div", { key: 'abe91b4c50a08da50888176662a565438ea5ed64', class: "ux-row" }, h("div", { key: '5a66d655a30afa4e05132d29c92d36b377fba837', class: "ux-col-12 ux-col-md-6" }, h("div", { key: 'f346025e3da3ec0823ff2f51a18e6c03da8bdec3', class: "ux-u-margin-bottom-20" }, h(SoftwareTypeSelect, { key: 'd7e7f5f80d258de88985278f1880af4ab2fa5e67', t: t, prefillData: prefillData, formStore: this.formStore, apiStore: this.apiStore }))), showSoftwareModules && (h("div", { key: '937bb548f8aa466ec4607c41329fa430dd3a4ff3', class: "ux-col-12 ux-col-md-6" }, h("div", { key: 'b1218048d5aa9200b66f3a52cd7083528daea271', class: "ux-u-margin-bottom-20" })))), h("div", { key: 'f355c3dda879deb96b583653abbc121c599eaf1c', class: "ux-row" }, showSoftwareModules && (h("div", { key: '3a4ac7f2ae51adb8e9899298c774ff3385fe1ee7', class: "ux-col-12 ux-col-md-6" }, h("div", { key: '1a7a7e4f19a2da1acf6add7296970479e38928af', class: "ux-u-margin-bottom-20" }, h(SoftwareModuleSelect, { key: '7b3812809320d619054c040d6aa0f12cff00183b', t: t, prefillData: prefillData, formStore: this.formStore, apiStore: this.apiStore }))))))), showErrorNumbers && (h("div", { key: 'e028355bc75537ffdf385a9e6124e69b6f509332', class: "ux-row" }, h("div", { key: '79d4c0589918b18e72aa544912536d1cc6445fdf', class: "ux-col-12" }, h(ErrorNumberInput, { key: 'c4d374b6d479f23947ef17425476e8d2754098a1', t: t, formStore: this.formStore, prefillData: prefillData })))), h("div", { key: 'e0cc631210b7b9df221077b04e014f8753e13b67', class: "ux-row" }, h("div", { key: '8f041d40d3c63d1a8da481923e94354634d9c4be', class: "ux-col-12" }, h("div", { key: 'd512c277bcf2b24f32759adb43617c937305319b', class: "ux-u-margin-bottom-20" }, h(DescriptionInput, { key: '1c9f1d89079299bef7d704a8348cb8d68f346f4c', t: t, prefillData: prefillData })))), this.fileUpload && (h("div", { key: '6b3fcf41fb0c6796fe4d39fc53e86be6b05b3583', class: "ux-row" }, h("div", { key: 'e7ddd74a984cd75604d30e387845be071c6143b8', class: "ux-col-12" }, h("div", { key: 'c118a4f1a00f631fce36b49bc19e7cb340e0edae', class: "ux-u-margin-bottom-20" }, h("ux-file-upload", { key: '080884ae0b40071884d7fc90451c81c4f3e43e6b', "max-file-size": "50", label: t("field.fileUpload.label"), "accepted-files": "image/*,application/*,text/*,video/mp4,", "max-files": "4" }), h("p", { key: '7841c4fc9e4f93044fe19c9c34e3505f8d68908d', class: "ux-text-tiny" }, t("field.fileUpload.info")))))), h(StepNext, { key: '1267cd621ed8b090b073c575960fe53c0ca6e6ca', t: t, multipleSteps: multipleSteps, onCancel: () => this.onCancel() })))), h(FormStep, { key: '836c21d1f9c69c6b30ae579046e52184973dd566', multipleSteps: multipleSteps }, h(StepNavigation, { key: 'cf42d64aeb441a9cc8c973bb1744d8b1374aa661', t: t, multipleSteps: multipleSteps, currentStep: 2 }), h("div", { key: 'cb54c72ae321b0754ced11c943902b62bb9dab60', class: "ux-row ux-u-flex-jc-center" }, h("div", { key: '3d184809ff304f3604f77961e9adcc4c5ef4ce04', class: "fields-wrapper ux-col-12 ux-col-md-10" }, h("div", { key: '01e1ae5c0c5805b180531bda30ca9347c01cfb7a' }, h("slot", { key: '3b8d22ef14158ec03823bddb64de1e7eed1d2fa6', name: "contacts-button" })), h("div", { key: 'f6a8363b1ec818d25f05b07dce1dca6974d697b8', class: "ux-row" }, h("div", { key: '1431e7b5b839f6351153602ad1337071afd35b0f', class: "ux-col-12 ux-col-md-6" }, h("div", { key: 'ccc35b2ffbb636f1333011effb54f63c3fc9e1b3', class: "ux-u-margin-bottom-20" }, h(SalutationInput, { key: '547ffc0b424c39efd9de3dc1b7961f2b47f7ebce', t: t, apiStore: this.apiStore })))), h("div", { key: '53535a3673cf634f66b07aad44ad7845c28b3a0d', class: "ux-row" }, h("div", { key: 'a50472b6dd5ffefb4459d6e834d0ed0d85cb68bb', class: "ux-col-12 ux-col-md-6" }, h("div", { key: '2ceb0e5a5c045dfddb0b93dd8d068f48b8bf74e0', class: "ux-u-margin-bottom-20" }, h(FirstNameInput, { key: '15178c181d060f81f1bd1240d33683044547aeff', t: t, apiStore: this.apiStore }))), h("div", { key: 'dd2b9ae1d177e8fa227176080fc095511d8a2a88', class: "ux-col-12 ux-col-md-6" }, h("div", { key: 'ba9842e63f7518f38d5238d30671ccbf633a3674', class: "ux-u-margin-bottom-20" }, h(LastNameInput, { key: '326efc74ae06f93f54c072ea709d0e4eaab45dc6', t: t, apiStore: this.apiStore })))), h("div", { key: '9771c943930249e88fc649560f80eb4acb8eeee3', class: "ux-row" }, h("div", { key: '88955220a317d93362037f7989def24d49fa257e', class: "ux-col-12 ux-col-md-6" }, h("div", { key: 'f06af210fb9fdf51e5a8b267002e84274cb155dc', class: "ux-u-margin-bottom-20" }, h(PhoneInput, { key: '563e8190415bbd9ae70d97928dbdcd3079c13bb9', t: t, apiStore: this.apiStore, locale: this.locale }))), h("div", { key: '0d457f3b5745507deabf488fb591d61f390a172a', class: "ux-col-12 ux-col-md-6" }, h("div", { key: 'e06e2a7870e163010288fec3fb7833c6398d35b9', class: "ux-u-margin-bottom-20" }, h(EmailInput, { key: '2ec7d6c7fcf20f6d76cb9a20d3cf19a0808e7338', t: t, apiStore: this.apiStore })))), h("div", { key: '5144d9e13f6ed965eaf62edf6898bc4430edfe06', class: "ux-u-margin-bottom-20" }, h("div", { key: '22db5bbd2abf9b30f4edb589e9ae3150149a895c', class: "ux-text-normal ux-text-normal--light-gray" }, h("p", { key: 'c34237d3d9035905c4d577e02a7076997e990801' }, t("validation.requiredFieldsExplanation")))), h("div", { key: '4ccc07047876b95477e1aeb088393b350ffe51ef', class: "ux-u-d-flex ux-u-flex-jc-between ux-u-flex-dir-row-reverse" }, h("ux-button", { key: '5cc32ac95a6b2bf0badec0ed460978127075046d', type: "submit", variant: "primary" }, t("button.submit")), h(StepBack, { key: '4582c6501ba13821c5ba67855a3fd3ec88a633b0', t: t, multipleSteps: multipleSteps }), !multipleSteps && (h("ux-button", { key: '5002621012d0e33c2d2235e8ce023d9e6e433630', type: "button", onClick: () => this.onCancel(), formnovalidate: true }, t("button.cancel")))))))))))), h("div", { key: '1504c589f2fd47534871388ad76e82f7dc41da38', style: { display: formIsSubmitted ? "block" : "none" } }, h("slot", { key: 'd9bccdf953d1476a4cdd95b59ce717cd19eeda0e', name: "connector" })), h(SilentAuth, { key: '2f92a9f99b701178bfeb0957672b3907bfb7d391', config: this.config, disabled: this.disableSilentAuth, authStore: this.authStore })));
    }
    static get watchers() { return {
        "locale": ["onLocaleChange"],
        "prefillData": ["onPrefillDataChange"]
    }; }
};
MfCreateServiceCase.style = createServiceCaseCss;

export { MfCreateServiceCase as mf_create_service_case };
//# sourceMappingURL=mf-create-service-case.entry.js.map

//# sourceMappingURL=mf-create-service-case.entry.js.map